import { authState } from '../state/auth.js';

export function useAuth() {
  const state = authState.value;

  function hasPermission(resource, action) {
    if (state.isPlatformAdmin) return true;
    return state.roles.some(role => {
      try {
        const perms = typeof role.permissions_json === 'string'
          ? JSON.parse(role.permissions_json)
          : role.permissions_json;
        return perms?.[resource]?.includes(action);
      } catch {
        return false;
      }
    });
  }

  // The environment someone works in: a club, or a sportcomplex (punt 4) with its own menu
  const activeClub = (state.clubs || []).find(c => Number(c.id) === Number(state.activeClubId)) || null;
  const isComplex = activeClub?.kind === 'sportcomplex';

  return { ...state, hasPermission, activeClub, isComplex };
}
